// source: netop_rc_route.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var netop_rc_tracing_pb = require('./netop_rc_tracing_pb.js');
goog.object.extend(proto, netop_rc_tracing_pb);
goog.exportSymbol('proto.netop.rc.route.Meta', null, global);
goog.exportSymbol('proto.netop.rc.route.ResolveAddressRequest', null, global);
goog.exportSymbol('proto.netop.rc.route.ResolveAddressResponse', null, global);
goog.exportSymbol('proto.netop.rc.route.ResolveAgentAddressRequest', null, global);
goog.exportSymbol('proto.netop.rc.route.ResolveAgentAddressResponse', null, global);
goog.exportSymbol('proto.netop.rc.route.RouteMessage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.Meta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.route.Meta.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.route.Meta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.Meta.displayName = 'proto.netop.rc.route.Meta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.RouteMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.route.RouteMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.RouteMessage.displayName = 'proto.netop.rc.route.RouteMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.ResolveAddressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.route.ResolveAddressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.ResolveAddressRequest.displayName = 'proto.netop.rc.route.ResolveAddressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.ResolveAddressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.route.ResolveAddressResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.route.ResolveAddressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.ResolveAddressResponse.displayName = 'proto.netop.rc.route.ResolveAddressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.ResolveAgentAddressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.route.ResolveAgentAddressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.ResolveAgentAddressRequest.displayName = 'proto.netop.rc.route.ResolveAgentAddressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.route.ResolveAgentAddressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.route.ResolveAgentAddressResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.route.ResolveAgentAddressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.route.ResolveAgentAddressResponse.displayName = 'proto.netop.rc.route.ResolveAgentAddressResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.route.Meta.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.Meta.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.Meta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.Meta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.Meta.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    replyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    traceList: jspb.Message.toObjectList(msg.getTraceList(),
    netop_rc_tracing_pb.TraceMessage.toObject, includeInstance),
    retryMeta: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.Meta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.Meta;
  return proto.netop.rc.route.Meta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.Meta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.Meta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = new netop_rc_tracing_pb.TraceMessage;
      reader.readMessage(value,netop_rc_tracing_pb.TraceMessage.deserializeBinaryFromReader);
      msg.addTrace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetryMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.Meta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.Meta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.Meta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.Meta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReplyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTraceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      netop_rc_tracing_pb.TraceMessage.serializeBinaryToWriter
    );
  }
  f = message.getRetryMeta();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.netop.rc.route.Meta.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.Meta} returns this
 */
proto.netop.rc.route.Meta.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reply_id = 2;
 * @return {string}
 */
proto.netop.rc.route.Meta.prototype.getReplyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.Meta} returns this
 */
proto.netop.rc.route.Meta.prototype.setReplyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.netop.rc.route.Meta.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.route.Meta} returns this
 */
proto.netop.rc.route.Meta.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated netop.rc.tracing.TraceMessage trace = 4;
 * @return {!Array<!proto.netop.rc.tracing.TraceMessage>}
 */
proto.netop.rc.route.Meta.prototype.getTraceList = function() {
  return /** @type{!Array<!proto.netop.rc.tracing.TraceMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, netop_rc_tracing_pb.TraceMessage, 4));
};


/**
 * @param {!Array<!proto.netop.rc.tracing.TraceMessage>} value
 * @return {!proto.netop.rc.route.Meta} returns this
*/
proto.netop.rc.route.Meta.prototype.setTraceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.netop.rc.tracing.TraceMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.tracing.TraceMessage}
 */
proto.netop.rc.route.Meta.prototype.addTrace = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.netop.rc.tracing.TraceMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.route.Meta} returns this
 */
proto.netop.rc.route.Meta.prototype.clearTraceList = function() {
  return this.setTraceList([]);
};


/**
 * optional string retry_meta = 5;
 * @return {string}
 */
proto.netop.rc.route.Meta.prototype.getRetryMeta = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.Meta} returns this
 */
proto.netop.rc.route.Meta.prototype.setRetryMeta = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.RouteMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.RouteMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.RouteMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.RouteMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.route.Meta.toObject(includeInstance, f),
    from: jspb.Message.getFieldWithDefault(msg, 3, ""),
    to: jspb.Message.getFieldWithDefault(msg, 4, ""),
    body: msg.getBody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.RouteMessage}
 */
proto.netop.rc.route.RouteMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.RouteMessage;
  return proto.netop.rc.route.RouteMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.RouteMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.RouteMessage}
 */
proto.netop.rc.route.RouteMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.route.Meta;
      reader.readMessage(value,proto.netop.rc.route.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.RouteMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.RouteMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.RouteMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.RouteMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.route.Meta.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.route.RouteMessage.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.RouteMessage} returns this
 */
proto.netop.rc.route.RouteMessage.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.RouteMessage.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.route.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.route.Meta, 2));
};


/**
 * @param {?proto.netop.rc.route.Meta|undefined} value
 * @return {!proto.netop.rc.route.RouteMessage} returns this
*/
proto.netop.rc.route.RouteMessage.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.route.RouteMessage} returns this
 */
proto.netop.rc.route.RouteMessage.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.route.RouteMessage.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string from = 3;
 * @return {string}
 */
proto.netop.rc.route.RouteMessage.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.RouteMessage} returns this
 */
proto.netop.rc.route.RouteMessage.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string to = 4;
 * @return {string}
 */
proto.netop.rc.route.RouteMessage.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.RouteMessage} returns this
 */
proto.netop.rc.route.RouteMessage.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bytes body = 5;
 * @return {!(string|Uint8Array)}
 */
proto.netop.rc.route.RouteMessage.prototype.getBody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes body = 5;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */
proto.netop.rc.route.RouteMessage.prototype.getBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBody()));
};


/**
 * optional bytes body = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */
proto.netop.rc.route.RouteMessage.prototype.getBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.netop.rc.route.RouteMessage} returns this
 */
proto.netop.rc.route.RouteMessage.prototype.setBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.ResolveAddressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.ResolveAddressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAddressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.route.Meta.toObject(includeInstance, f),
    entityId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.ResolveAddressRequest}
 */
proto.netop.rc.route.ResolveAddressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.ResolveAddressRequest;
  return proto.netop.rc.route.ResolveAddressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.ResolveAddressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.ResolveAddressRequest}
 */
proto.netop.rc.route.ResolveAddressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.route.Meta;
      reader.readMessage(value,proto.netop.rc.route.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.ResolveAddressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.ResolveAddressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAddressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.route.Meta.serializeBinaryToWriter
    );
  }
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.route.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.route.Meta, 2));
};


/**
 * @param {?proto.netop.rc.route.Meta|undefined} value
 * @return {!proto.netop.rc.route.ResolveAddressRequest} returns this
*/
proto.netop.rc.route.ResolveAddressRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.route.ResolveAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string entity_id = 3;
 * @return {string}
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAddressRequest.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.route.ResolveAddressResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.ResolveAddressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.ResolveAddressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAddressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.route.Meta.toObject(includeInstance, f),
    addressesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.ResolveAddressResponse}
 */
proto.netop.rc.route.ResolveAddressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.ResolveAddressResponse;
  return proto.netop.rc.route.ResolveAddressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.ResolveAddressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.ResolveAddressResponse}
 */
proto.netop.rc.route.ResolveAddressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.route.Meta;
      reader.readMessage(value,proto.netop.rc.route.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddresses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.ResolveAddressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.ResolveAddressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAddressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.route.Meta.serializeBinaryToWriter
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.route.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.route.Meta, 2));
};


/**
 * @param {?proto.netop.rc.route.Meta|undefined} value
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
*/
proto.netop.rc.route.ResolveAddressResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string addresses = 3;
 * @return {!Array<string>}
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.getAddressesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.setAddressesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.addAddresses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.route.ResolveAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAddressResponse.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.ResolveAgentAddressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.ResolveAgentAddressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAgentAddressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.route.Meta.toObject(includeInstance, f),
    sessionKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.ResolveAgentAddressRequest;
  return proto.netop.rc.route.ResolveAgentAddressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.ResolveAgentAddressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.route.Meta;
      reader.readMessage(value,proto.netop.rc.route.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.ResolveAgentAddressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.ResolveAgentAddressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAgentAddressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.route.Meta.serializeBinaryToWriter
    );
  }
  f = message.getSessionKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.route.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.route.Meta, 2));
};


/**
 * @param {?proto.netop.rc.route.Meta|undefined} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest} returns this
*/
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string session_key = 3;
 * @return {string}
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.getSessionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressRequest} returns this
 */
proto.netop.rc.route.ResolveAgentAddressRequest.prototype.setSessionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.route.ResolveAgentAddressResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.route.ResolveAgentAddressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.route.ResolveAgentAddressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAgentAddressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.route.Meta.toObject(includeInstance, f),
    addressesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.route.ResolveAgentAddressResponse;
  return proto.netop.rc.route.ResolveAgentAddressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.route.ResolveAgentAddressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.route.Meta;
      reader.readMessage(value,proto.netop.rc.route.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddresses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.route.ResolveAgentAddressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.route.ResolveAgentAddressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.route.ResolveAgentAddressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.route.Meta.serializeBinaryToWriter
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.route.Meta}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.route.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.route.Meta, 2));
};


/**
 * @param {?proto.netop.rc.route.Meta|undefined} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
*/
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string addresses = 3;
 * @return {!Array<string>}
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.getAddressesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.setAddressesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.addAddresses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.route.ResolveAgentAddressResponse} returns this
 */
proto.netop.rc.route.ResolveAgentAddressResponse.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


goog.object.extend(exports, proto.netop.rc.route);
